// extracted by mini-css-extract-plugin
export default {"Container":"AssessmentInfo_Container__PT25j","AssessmentInfo":"AssessmentInfo_AssessmentInfo__v51-b"};